var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4997 0H2.49969C2.2236 0 2 0.224064 2 0.50016V9.50016C2 9.63282 2.0525 9.75985 2.14626 9.8536C2.24001 9.94734 2.36703 9.99985 2.49969 9.99985H11.4997C11.6324 9.99985 11.7599 9.94735 11.8536 9.8536C11.9473 9.75984 11.9999 9.63282 11.9999 9.50016V0.50016C11.9999 0.3675 11.9474 0.24 11.8536 0.146256C11.7598 0.052512 11.6323 0 11.4997 0V0ZM11 9H2.99984V0.99984H11V9Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99985 11.0002H0.999852V5.00016C0.999852 4.72406 0.776256 4.5 0.50016 4.5C0.224064 4.5 0 4.72406 0 5.00016V11.4998C0 11.6325 0.0525 11.76 0.146256 11.8537C0.240012 11.9475 0.367512 12 0.50016 12H6.99984C7.27594 12 7.5 11.7759 7.5 11.4998C7.5 11.2237 7.27594 11.0001 6.99984 11.0001L6.99985 11.0002Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49969 5.49985H6.49953V6.49969L6.5 6.50016C6.5 6.77626 6.7236 6.99985 6.99969 6.99985C7.27579 6.99985 7.49985 6.77626 7.49985 6.50016V5.49985H8.49969C8.77579 5.49985 8.99985 5.27626 8.99985 5.00016C8.99985 4.72406 8.77579 4.5 8.49969 4.5H7.49985V3.50016C7.49985 3.22406 7.27579 3 6.99969 3C6.7236 3 6.5 3.22406 6.5 3.50016V4.5H5.49969C5.2236 4.5 5 4.72406 5 5.00016C5 5.27626 5.2236 5.49985 5.49969 5.49985L5.49969 5.49985Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDocument);
export default __webpack_public_path__ + "static/media/add-document.2cf69968.svg";
export { ForwardRef as ReactComponent };